'use strict';

import template from './cookies_line_modal.html';


var controller = function ($rootScope, $scope, userModel) {
  'ngInject';
  var self = this;
  self.analytics     = $rootScope.analytics !== undefined ? $rootScope.analytics : true;
  self.facebookPixel = $rootScope.facebookPixel!== undefined ? $rootScope.facebookPixel : true;
  self.adWords       = $rootScope.adWords!== undefined ? $rootScope.adWords : true;
  self.taboola       = $rootScope.taboola !== undefined ? $rootScope.taboola : true;

  self.confirm = function(){
    $rootScope.analytics            = self.analytics;
    $rootScope.facebookPixel        = self.facebookPixel;
    $rootScope.adWords              = self.adWords;
    $rootScope.taboola              = self.taboola;
    $rootScope.isCookiesLineEnabled = false;
    self.done();
  }
};

export default function () {
  return {
    template: template,
    replace: true,
    scope: {
      done: '&',
    },
    bindToController: true,
    controllerAs: 'ctrl',
    controller: controller,
  };
}



// WEBPACK FOOTER //
// ./app/src/directives/cookies_line_modal.js